import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { Row, Col, Button } from 'antd';
import { IconHelper, logoutByUser, charectorLength, setCookie } from '../helpers'
import { isEmpty } from 'lodash';
import { translate } from 'react-i18next'
import i18n from '../i18n'
import { connect } from 'react-redux'
import { SET_LANGUAGE } from '../redux/actions/type'
import { login } from '../helpers'


const LeftBar = ({ t, switchLanguage, language, contextInfo }) => {
    const { IconUser, IconClose, IconEN, IconTH, IconCN, IconMenuSupport, IconContact, IconMenuPrice, IconMenuMeeting, IconMenuMyRecords } = IconHelper
    const [context, setContext] = useState({
        avatar: '',
        name: '',
        p: '',
        pkgcode: '',
    })
    const [imgUrl, setImgUrl] = useState({
        src: '',
        errored: false
    })
    const leftMenuClose = () => {
        const leftMenu = document.getElementsByClassName('leftMenu')[0];
        const bgBlack = document.getElementsByClassName('bgBlack')[0];
        // document.body.style.overflow = 'auto'
        leftMenu.style.left = '-300px'
        bgBlack.style.display = 'none'
    }
    const keycloak = useSelector(state => state.keycloak)
    const { authenticated } = useSelector(state => state.keycloak)

    const logout = () => {
        logoutByUser(keycloak)
    }

    const imgError = () => {
        if (!imgUrl.errored) {
            setImgUrl({
                src: `${process.env.PUBLIC_URL}/img/Mask_Group.png`,
                errored: true,
            })
        }
    }

    useEffect(() => {
        if (authenticated && !isEmpty(keycloak)) {
            setContext({
                ...contextInfo,
                name: contextInfo.name.split(" ")[0] || ''
            })
            setImgUrl({
                src: contextInfo.avatar,
                errored: false,
            })
        }
    }, [authenticated, keycloak, setImgUrl, contextInfo])

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng)
        setCookie('language', lng)
        switchLanguage(lng)
    }
    const initialLanguage = { overflow: 'initial', top: '-5px', cursor: 'pointer' }
    return (
        <>
            <Row>
                <Col span={24}>
                    <div className="leftMenu">
                        <div className="leftMenuSec1">
                            <Row type="flex" justify="center">
                                <Col span={8} id="leftMenuUser">
                                    {!authenticated ? (
                                        <IconUser style={{
                                            background: '#fff',
                                            borderRadius: '50px'
                                        }} />) : (
                                        <div className="userImg">
                                            {/* eslint-disable-next-line */}
                                            <img src={imgUrl.src} onError={imgError} />
                                        </div>
                                    )
                                    }
                                </Col>
                            </Row>
                            <Row type="flex" justify="center">
                                <Col span={18} className="leftUserText">
                                    <label>{t('menu_greet')}</label>
                                    {context.name.length > 15 ?
                                        <label>{authenticated ?
                                            charectorLength(context.name)
                                            : t("guest")}</label>
                                        :
                                        <label>{authenticated ?
                                            context.name
                                            : t("guest")}</label>
                                    }
                                </Col>
                            </Row>
                            {/* <Row type="flex" justify="center">
                                <Col span={12} className="leftPackageText">
                                    <label>แพ็กเกจของคุณคือ</label>
                                    <div>
                                        {authenticated ? context.pkgcode : 'Guest'}
                                    </div>
                                </Col>
                            </Row> */}
                        </div>
                        <div className="leftMenuSec2">
                            <Row type="flex" justify="center">
                                <Col span={14} className="leftUpgradeText">
                                    {
                                        !authenticated ? (
                                            <p>{t('left_bar_text')}</p>
                                        ) : ('')
                                    }
                                    {/* <Button>
                                        <NavLink exact to="/portal/package" activeClassName="active">{t('menu_package')}</NavLink>
                                    </Button> */}
                                    {
                                        authenticated ? (
                                            <Button onClick={logout}>
                                                {t('menu_logout')}
                                            </Button>
                                        ) : (
                                            <Button onClick={login.bind(this, keycloak, language)}>
                                                {t('button_signin')}
                                            </Button>
                                        )
                                    }
                                </Col>
                            </Row>
                        </div>
                        {/* <div className="leftMenuSetup">    
                            <span id="txt-setup"><SettingOutlined />  ตั้งค่า  </span>
                        </div> */}
                        <div className="leftMenuSec3">
                            <Row type="flex" justify="center">
                                <Col span={17} className="menu">
                                    <ul>
                                        {/* <li>
                                            <NavLink exact to="/portal" activeClassName="active">หน้าแรก</NavLink>
                                        </li> */}
                                        {keycloak.authenticated
                                            ? <li>
                                                <a href={window._env_.mymeeting} activeclassname="">
                                                    <IconMenuMeeting style={{ marginRight: '15px' }} />
                                                    {t("menu_reservation")}
                                                </a>
                                            </li>
                                            : null}
                                        {
                                            parseInt(window._env_.isShowPlanPrice) === 1 ? (
                                                <li>
                                                    <a href={window._env_.subscriptionPlanspricing}>
                                                        <IconMenuPrice style={{ marginRight: '15px' }} />
                                                        {t("menu_price")}

                                                    </a>
                                                </li>
                                            ) : null
                                        }
                                        { authenticated ? <li onClick={leftMenuClose}>
                                            <a href={window._env_.vRoomUrl + "/portal/myrecords"}>
                                                <IconMenuMyRecords
                                                    style={{ marginRight: '10px' }}
                                                    viewBox={`0 0 19 14`}
                                                />
                                                {t("menu_my_records")}
                                            </a>
                                        </li> : null}
                                        <li>
                                            <a href={window._env_.SUPPORT_WEB}>
                                                <IconMenuSupport
                                                    style={{ marginRight: '10px' }}
                                                    viewBox={`0 0 17 17`}
                                                />
                                                {t("menu_support")}
                                            </a>
                                        </li>
                                        {
                                            parseInt(window._env_.isShowContactPage) === 1
                                                ? (<li>
                                                    <a href={`${window._env_.vRoomUrl}/portal/contact`}>
                                                        <IconContact
                                                            style={{ marginRight: '10px' }}

                                                        />
                                                        {t("menu_contact_page")}
                                                    </a>
                                                </li>
                                                ) : null
                                        }
                                    </ul>
                                </Col>
                            </Row>
                        </div>
                        <div className="leftMenuSec3">
                            <Row type="flex" justify="center">
                                <Col span={24} className="menuLeft">
                                    <ul>
                                        <li className="icon-language">
                                            <IconTH
                                                width="30"
                                                height="30"
                                                style={
                                                    language === 'th' ? { ...initialLanguage } : { filter: 'grayscale(1)', ...initialLanguage }
                                                }
                                                onClick={changeLanguage.bind(this, 'th')} />
                                            <IconEN
                                                width="30"
                                                height="30"
                                                style={
                                                    language === 'en' ? { ...initialLanguage } : { filter: 'grayscale(1)', ...initialLanguage }
                                                }
                                                onClick={changeLanguage.bind(this, 'en')} />
                                            <IconCN
                                                width="30"
                                                height="30"
                                                style={
                                                    language === 'cn' ? { ...initialLanguage } : { filter: 'grayscale(1)', ...initialLanguage }
                                                }
                                                onClick={changeLanguage.bind(this, 'cn')} />
                                        </li>
                                    </ul>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Col>
                <Col span={24}>
                    <div className="bgBlack" onClick={leftMenuClose}>
                        <IconClose style={{
                            left: "310px",
                            top: "10px",
                            position: "relative",
                            cursor: "pointer",
                            zIndex: 5
                        }}
                            onClick={leftMenuClose} />
                    </div>
                </Col>
            </Row>
        </>
    )
}

const mapStateToProps = state => ({
    language: state.language,
    contextInfo: state.contextInfo
})

const mapDispatchToProps = dispatch => ({
    switchLanguage: (lang) => {
        dispatch({
            type: SET_LANGUAGE,
            payload: lang
        })
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(translate()(LeftBar))